import { appConfig } from 'config/environment/appConfig'

import { HttpService } from 'services/HttpService'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'

import { PersonalUserDataDTO } from './types/types'

const discoveryService = new HttpService(appConfig.DISCOVERY_URL)

export const personalDataApi = {
  async getUserData(user_id: number): Promise<PersonalUserDataDTO> {
    const result = await discoveryService.get(`api/v2/pickpoint_user/${user_id}/info`)
    return convertKeysToCamelCase(result)
  },
}
